import { useNavigate } from "react-router-dom";
import { EWI_NOTIFICATION_STATUS } from "../../../utils/global";

export const InsightsTourContent = ({
  image,
  title,
  description,
  ewi_status,
  idrssd,
  onClose,
}) => {
  const navigate = useNavigate();
  return (
    <div className="InsightsTourContent">
      <img
        src={image}
        alt={title}
        style={{
          width: "100%",
          marginBottom: 24,
        }}
      />
      <h5 dangerouslySetInnerHTML={{ __html: title }} />
      <p className="description">{description}</p>
      {ewi_status && (
        <button
          className="primary-btn"
          onClick={() => {
            if (ewi_status === EWI_NOTIFICATION_STATUS.EXIST) {
              localStorage.setItem("insights-tour-shown", "true");
              onClose();
              navigate(`/bank/health-analysis/report/${idrssd}/ewiChatBot/ewi`);
            } else {
              localStorage.setItem("insights-tour-shown", "true");
              onClose();
            }
          }}
        >
          {ewi_status === EWI_NOTIFICATION_STATUS.EXIST
            ? " View Insights"
            : "Got It"}
        </button>
      )}
    </div>
  );
};
